/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDobbiesUnbxdRecommendationsViewProps } from './dobbies-unbxd-recommendations';
import { INodeProps, SingleSlideCarousel, Node, Waiting } from '@msdyn365-commerce-modules/utilities';

export default (props: IDobbiesUnbxdRecommendationsViewProps) => {
    const {
        carouselItems,
        loading,
        config: { carouselHeading, isTabItem }
    } = props;

    if (loading) {
        return (
            <div className='ms-product-collection'>
                <Waiting className='msc-waiting-circular msc-waiting-md' />
            </div>
        );
    }

    if (!carouselItems || carouselItems.length === 0) {
        props.context.telemetry.error('Product Recommendations is empty, module wont render.');
        return isTabItem ? <div className='not-found-error'>No data found</div> : null;
    }

    return carouselItems && carouselItems.length > 0 ? (
        <div className='msc-active-image'>
            <div className='ms-product-collection'>
                {props.config.showAddToBasket && props.slots.storeSelectors}
                {!isTabItem && (
                    <div className='ms-product-collection__heading'>
                        <h2>{carouselHeading && carouselHeading !== '' ? carouselHeading : props.widgetTitle}</h2>
                    </div>
                )}
                <SingleSlideCarousel key={carouselItems.length}>
                    {carouselItems.map((item, index) => {
                        const ProductContainer: INodeProps = {
                            tag: 'li',
                            className: `ms-product-collection__item msc-active-shadow ${item.product.RecordId}-product`,
                            role: 'listitem'
                        };
                        return (
                            <Node
                                {...ProductContainer}
                                key={index}
                                data-product-url={item.productUrl}
                                unbxdparam_pid={item.product.RecordId}
                                data-product-id={item.product.RecordId}
                                widgetid={props.config.widgetNumber?.toUpperCase()}
                                unbxdparam_experience_pagetype={props.config.pageType.toUpperCase()}
                                unbxdparam_experience_widget={props.config.widgetNumber?.toUpperCase()}
                            >
                                {item.carouselItem}
                            </Node>
                        );
                    })}
                </SingleSlideCarousel>
            </div>
        </div>
    ) : (
        <></>
    );
};
